// extracted by mini-css-extract-plugin
module.exports = {"item_p":"styles_item_p__Vqnxg","img_mobile":"styles_img_mobile__c3EDK"};